export default "/images/vendor/flag-icons/flags/4x3/si.svg?7b5de0936324469726303d96ffd2ccdf";